import { render } from "./RouteLegsInfo.vue?vue&type=template&id=eede3b2c&scoped=true"
import script from "./RouteLegsInfo.vue?vue&type=script&lang=js"
export * from "./RouteLegsInfo.vue?vue&type=script&lang=js"

import "./RouteLegsInfo.vue?vue&type=style&index=0&id=eede3b2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eede3b2c"]])

export default __exports__